{
  "save": "Lagre",
  "back": "Tilbake",
  "goback": "Gå tilbake",
  "next": "Gå videre",
  "ok": "Ok",
  "cancel": "Avbryt",
  "close": "Lukk",
  "submit": "Send inn",
  "yes": "Ja",
  "no": "Nei",
  "edit": "Endre",
  "delete": "Slett",
  "save.and.ask.approval": "Lagre og be om godkjenning",
  "meddommer": "Meddommer",
  "election.period": "Valgperiode",
  "national.identity.number": "Fødselsnummer",
  "national.identity.number.detailed": "Fødselsnummer (11 siffer)",
  "fylke": "Fylke",
  "note": "Notat",
  "name": "Navn",
  "first.name": "Fornavn",
  "last.name": "Etternavn",
  "sex": "Kjønn",
  "women": "Kvinner",
  "men": "Menn",
  "address": "Adresse",
  "phone.number": "Telefonnummer",
  "phone.number.work": "Arbeidstelefon",
  "email": "E-post",
  "zip": "Postnummer",
  "work.zip": "Arbeidsadressepostnummer",
  "birth.year": "Fødselsår",
  "occupation": "Yrke",
  "type": "Type",
  "reason": "Årsak",
  "position": "Stilling",
  "knowledge.category": "Kyndighetskategori",
  "knowledge.categories": {
    "Arealplanlegger": "Arealplanlegger",
    "Landbruk": "Landbruk",
    "Skogbruk": "Skogbruk",
    "Entreprenoer": "Entreprenør",
    "Megler": "Megler",
    "Takstmann": "Takstmann",
    "RevisorOekonomi": "Revisor Økonomi",
    "Eiendomsutvikler": "Eiendomsutvikler",
    "Arkitekt": "Arkitekt",
    "FastEiendom": "Fast Eiendom",
    "Reindrift": "Reindrift",
    "Annet": "Annet"
  },
  "knowledge.speciality": "Særlig kyndig i",
  "workplace": "Arbeidssted",
  "work.address": "Arbeidsadresse",
  "work.address.location": "Arbeidsadressepoststed",
  "not.found.heading": "404 - Ikke funnet",
  "logout.button.label": "Logg ut",
  "loading": "Laster...",
  "loading.page": "Laster siden...",
  "required.fields.info": "Obligatoriske felter er merket med <0>*</0>",
  "frita": "Frita/slett",
  "logo.alt.text": "Norges Domstoler logo",
  "login.error.page": {
    "heading": "Det oppsto en feil under innlogging",
    "info": "Kontakt domstolene om problemet ikke løser seg.",
    "button.label": "Logg ut og prøv igjen"
  },
  "export.notification.error": "Kunne ikke eksportere til excel.",
  "startpage": {
    "heading": "Portal for meddommerutvalg",
    "info.public": "For ansatte i kommuner og fylkeskommuner som jobber med meddommerutvalg. Logg inn for å se meddommerbestillinger, registrere og frita meddommere.",
    "info.authenticated": "For ansatte i kommuner og fylkeskommuner som jobber med meddommerutvalg.",
    "login.button.label": "Logg inn",
    "report.button.label": "Meld inn meddommere",
    "innsyn": {
      "heading": "Offentlig innsyn i gjeldende meddommerutvalg",
      "text": "Velg enhet fra listen for å se valgte meddommer fra den enheten for inneværende periode.",
      "choose.kommune.text": "Velg en kommune for å se meddommere i tingretten, lagmannsretten eller jordskifteretten.",
      "choose.fylke.text": "Velg en fylkeskommune for å se skjønnsmedlemmer.",
      "choose.da.text": "Velg Domstoladministrasjonen for å se arbeidslivskyndige.",
      "enhet.label": "Kommune/fylkeskommune",
      "enhet.show": "Vis meddommere"
    }
  },
  "profil": {
    "heading": "Profil",
    "input": {
      "label": {
        "name": "Navn hentet fra folkeregisteret",
        "email": "Epost (arbeid)",
        "phone": "Kontortelefon (arbeid)",
        "terms": "Jeg samtykker til at det lagres personopplysninger.",
        "enhet": {
          "ikke.valgt": "Velg enhet",
          "godkjent": "Du er registrert som innmelder for"
        }
      },
      "placeholder": {
        "enhet": "Velg enhet fra listen"
      },
      "tip": {
        "enhet": "Søk etter din enhet (kommune/fylkeskommune)"
      }
    },
    "remove.enhet.button.label": "Fjern tilknytning",
    "awaiting.approval.message": "Du venter på å bli godkjent som innmelder for {{ enhet }}",
    "privacy.policy.link": "Les mer om Personvern og informasjonskapsler",
    "approval": {
      "heading": "Be om godkjenning",
      "info.message": "Beskriv kort rollen som gjør at du har behov for brukertilgang i portalen. Domstoladministrasjonen behandler og godkjenner registrering av nye brukere. Presiser gjerne om du skal to over jobben for noen.",
      "input.message.label": "Hva skal du bruke portalen til?",
      "submit.button.label": "Be om godkjenning"
    },
    "notifications": {
      "update": {
        "error": "Noe gikk galt under oppdatering av profil. {{ nativeError }}",
        "success": "Profil oppdatert"
      }
    }
  },
  "innsyn": {
    "heading": "Registrerte meddommere for {{ enhet }}",
    "search.name": "Søk etter navn",
    "meddommere.empty": "Ingen meddommere registrert for denne enheten.",
    "meddommere.search": "Søk etter navn"
  },
  "enhet": {
    "empty": "Ingen enhet valgt",
    "users": {
      "name": "{{ firstName }} {{ lastName }}",
      "name_pending-approval": "{{ firstName }} {{ lastName }} (venter på godkjenning)"
    }
  },
  "meddommerbehov": {
    "heading": "Meddommerbehov for {{enhetNavn}} ({{enhetNummer}})",
    "reporters.heading": "Innmeldere",
    "user.awaiting.approval.info": "Din forespørsel om godkjenning behandles av Domstoladministrasjonen. Når du blir godkjent vil du se meddommerbehov her.",
    "no.behov.found": "Fant ingen meddommerbehov for denne perioden.",
    "behov.deadline": "Frist {{ date }}",
    "hovedvalg": "Hovedvalg",
    "supplementsvalg": "Supplement",
    "report.status": {
      "_UKJENT": "Ukjent",
      "_IKKE_RAPPORTERT": "Innmelding ikke meldt inn",
      "_RAPPORTERING_PÅGÅR": "Rapportering pågår",
      "_RAPPORTERT_OK": "Innmelding fullført",
      "_RAPPORTERING_FEILET": "Innmelding feilet"
    },
    "type": {
      "_Meddommer": "Meddommer i tingretten",
      "_Meddommer_other": "Meddommere i tingrett",
      "_Lagmeddommer": "Meddommer i lagmannsretten",
      "_Lagmeddommer_other": "Meddommere i lagmannsrett",
      "_Jordskiftemeddommer": "Jordskiftemeddommer",
      "_Jordskiftemeddommer_other": "Jordskiftemeddommere",
      "_Skjønnsmedlem": "Skjønnsmedlem",
      "_Skjønnsmedlem_other": "Skjønnsmedlemmer",
      "_Arbeidslivskyndig": "Arbeidslivskyndig",
      "_Arbeidslivskyndig_other": "Arbeidslivskyndige",
      "_Ukjent": "Ukjent",
      "_Ukjent_other": "Ukjent"
    },
    "card.action.button": {
      "_start": "Meld inn",
      "_view": "Se innmelding"
    },
    "start.reporting.button.label": "Meld inn",
    "delete.modal": {
      "confirm.single": "Er du sikker på at du vil slette meddommer {{ firstName }} {{ lastName }}?",
      "confirm.multiple": "Er du sikker på at du vil slette den valgte meddommeren?",
      "confirm.multiple_other": "Er du sikker på at du vil slette {{ count }} meddommere?",
      "delete.button.label": "Slett meddommer",
      "delete.button.label_other": "Slett meddommere"
    },
    "register": {
      "heading": {
        "Meddommer": "Legg inn meddommere i tingrett",
        "Lagmeddommer": "Legg inn meddommere i lagmannsrett",
        "Jordskiftemeddommer": "Legg inn jordskiftemeddommere",
        "Skjønnsmedlem": "Legg inn skjønnsmedlemmer",
        "Arbeidslivskyndig": "Legg inn arbeidslivskyndige",
        "Ukjent": "Ukjent"
      },
      "excel.info.heading": "Excel-mal",
      "excel.info.text": "For å laste opp meddommere fra Excel må du ta utgangspunkt i malen nedenfor. Merk at malene kan variere per meddomertype.",
      "excel.link.text": {
        "Meddommer": "Excel-mal for meddommere i tingretten (.xlsx)",
        "Lagmeddommer": "Excel-mal for meddommere i lagmannsretten (.xlsx)",
        "Jordskiftemeddommer": "Excel-mal for jordskiftemeddommere (.xlsx)",
        "Skjønnsmedlem": "Excel-mal for skjønnsmedlemmer (.xlsx)",
        "Arbeidslivskyndig": "Excel-mal for arbeidslivskyndige (.xlsx)",
        "Ukjent": "Ukjent"
      },
      "number.of.meddommere": "Antall meddommere lagt inn: {{ count }}",
      "add.new.button.label": "Ny meddommer",
      "upload.button.label": "Last opp fra Excel",
      "delete.button.label": "Slett markerte",
      "export.button.label": "Eksporter til Excel",
      "submit": {
        "heading": "Innsending av utvalget",
        "info": "Når dette utvalget er sendt inn kan du ikke lenger redigere eller legge inn flere meddommere. Om du trenger å låse det opp igjen må du kontakte Domstoladministrasjonen.",
        "strafferettslig.vandelskontroll": {
          "label": "Det har blitt gjennomført strafferettslig vandelskontroll av utvalget",
          "law": "jf. domstolloven §72"
        },
        "oekonomisk.vandelskontroll": {
          "label": "Det har blitt utført økonomisk vandelskontroll eller blitt innhentet egenerklæring,",
          "law": "jf. domstolloven §70 tredje punkt"
        },
        "valgbarhet.kontroll.label": "Kandidatenes valgbarhet er kontrollert så langt det lar seg gjøre",
        "contact.info.verified.label": "Meddommernes kontaktinformasjon er oppdatert",
        "contact.info.verified.label_arbeidslivsorganisasjon": "Kandidatenes kontaktinformasjon er oppdatert"
      }
    },
    "upload.modal": {
      "heading": "Import av meddommere",
      "invalid.file.formatting": "Følgende feil i excel-arket må rettes før det kan lastes opp.",
      "number.of.meddommer.created": "{{ count }} ny meddommer lagt til",
      "number.of.meddommer.created_other": "{{ count }} nye meddommere lagt til",
      "number.of.meddommer.updated": "{{ count }} meddommer ble oppdatert",
      "number.of.meddommer.updated_other": "{{ count }} meddommere ble oppdatert",
      "number.of.meddommer.failed.validation": "{{ count }} meddommer feilet validering",
      "number.of.meddommer.failed.validation_other": "{{ count }} meddommere feilet validering",
      "number.of.meddommer.saved": "Totalt {{ savedCount }} av {{ submittedCount }} meddommere lagret i systemet.",
      "line": "Linje",
      "message": "Feilmelding(er)"
    },
    "add.edit.modal": {
      "search.ssn.info": "Skriv inn fødselsnummer for å søke i folkeregisteret."
    },
    "status": {
      "heading": {
        "_Meddommer": "Du har meldt inn meddommere i tingrett <0></0>",
        "_Lagmeddommer": "Du har meldt inn meddommere i lagmannsrett <0></0>",
        "_Jordskiftemeddommer": "Du har meldt inn jordskiftemeddommere <0></0>",
        "_Skjønnsmedlem": "Du har meldt inn  skjønnsmedlemmer <0></0>",
        "_Arbeidslivskyndig": "Du har meldt inn  arbeidslivskyndige <0></0>",
        "_Ukjent": "Ukjent"
      },
      "info.text": "Du har meldt inn {{ numberReported }} av {{ numberWanted }} etterspurte meddommere av typen {{ type }}. Du kan ikke lenger redigere eller legge inn flere meddommere i utvalget. Om du trenger å låse opp igjen for redigering må du <2>kontakte Domstoladministrasjonen.</2>"
    },
    "error": {
      "save": "Feil under lagring av meddommer: {{ nativeError }}",
      "save_generic": "Ukjent feil kunne ikke lagre meddommer.",
      "submit": "Ukjent feil under innsending av utvalget, vennligst prøv igjen senere."
    }
  },
  "fritak": {
    "heading": "Gi fritak eller slett meddommer",
    "user.awaiting.approval.info": "Din forespørsel om godkjenning behandles av Domstoladministrasjonen. Når du blir godkjent kan du melde fritak her.",
    "headingText1": "Du kan kun gi fritak for meddommere for hele valgperioden.",
    "headingText2": "Fritak fra enkeltsaker skal gis av domstolen.",
    "registered": "Fritak registrert for {{ name }}",
    "fritakFraDato": "Gjelder fra",
    "fnr": "Fødselsnummer for fritak (11 siffer)",
    "meddommerverv": {
      "registered": "Følgende meddommerverv er registrert i {{ enhet }}",
      "empty": "Ingen meddommerverv registrert"
    },
    "reason": {
      "_FRITAK_INNVILGET": "Meddommeren har fått innvilget permanent fritak.",
      "_FLYTTET": "Meddommeren har flyttet ut av rettskretsen eller lagsognet.",
      "_IKKE_VALGBAR": "Meddommeren oppfyller ikke valgbarhetsvilkårene etter domstolloven §§ 70-72."
    },
    "confirm.modal": {
      "heading": "Frita/slett meddommer?",
      "fritak.verv": "Fritas/Slettes som",
      "keep.verv": "Beholder rollen"
    },
    "confirmed.modal": {
      "heading": "Meddommer fritatt/slettet <0></0>",
      "fritak.verv": "Fritatt/slettet som",
      "keep.verv": "Har fortsatt rollen"
    }
  },
  "overfoering": {
    "heading": "Overfør meddommer til ny kommune",
    "user.awaiting.approval.info": "Din forespørsel om godkjenning behandles av Domstoladministrasjonen. Når du blir godkjent kan du overføre meddommere her.",
    "headingText": "Skriv inn fødselsnummeret til meddommer som har flyttet for å se om den kan overføres til ny kommune, eller må fritas grunnet flytting utenfor sognet.",
    "notOverfoerbar": "Meddommeren har registrert adresse i {{ enhet }}, og kan dermed ikke overføres. Det kan hende meddommeren ikke har meldt flytting til folkeregisteret.",
    "notOverfoerbarError": "Meddommeren er ikke overførbar",
    "fnr": "Fødselsnummer for overføring (11 siffer)",
    "meddommerverv": {
      "registered": "Følgende meddommerverv registrert i {{ enhet }}",
      "empty": "Ingen meddommerverv registrert"
    },
    "question": "Overføre meddommer?",
    "confirmed": "Meddommer overført",
    "overfoerAs": "Overføres som",
    "overfoerTo": "Overføres til",
    "overfoertAs": "Overført som",
    "overfoertTo": "Overført til",
    "verb": "Overfør",
    "registered": "Overføring registrert for {{ name }}"
  },
  "header": {
    "page.title": "Meddommerutvalg",
    "links": {
      "startpage": "Forside",
      "report": "Meld inn meddommere",
      "fritak": "Gi fritak eller slett meddommer",
      "overfoering": "Overfør meddommer"
    }
  },
  "footer": {
    "name.heading": "Domstoladministrasjonen",
    "organization.number": "Org.nr. 984 195 796",
    "postal.address": {
      "line.1": "Postadresse: Postboks 5678 Sluppen",
      "line.2": "7485 Trondheim"
    },
    "contact.heading": "Kontakt",
    "phone": "Telefon: 73 56 70 00",
    "mail": "postmottak@domstoladministrasjonen.no",
    "visiting.address": {
      "line.1": "Besøksadresse: Dronningensgate 2",
      "line.2": "7011 Trondheim"
    },
    "links": {
      "heading": "Lenker",
      "user.manual": "Brukerhåndbok",
      "privacy.cookie.notice": "Personvern og informasjonskapsler",
      "accessibility.notice": "Tilgjengelighetserklæring"
    }
  },
  "yup": {
    "validation": {
      "required": "Dette feltet er påkrevd.",
      "length": "{{ path }} må være {{ length }} tegn.",
      "valid.email": "\"{{ value }}\" er ikke en gyldig epostadresse",
      "terms.and.conditions": "Du må samtykke til at det lagres personopplysninger for å kunne bruke denne portalen.",
      "phone.only.numbers": "Telefonnummer kan kun inneholde tall."
    }
  },
  "aria": {
    "user.menu": "Bruker meny",
    "meddommer.table": {
      "checkbox": "Velg meddommer {{ meddommer }} med fødselsnummer {{ ssn }}",
      "select.all.checkbox": "Velg eller avvelg alle meddommere",
      "edit.column": "Endre meddommer kolonne",
      "delete.column": "Slett meddommer kolonne",
      "edit.button": "Rediger meddommer {{ meddommer }} med fødselsnummer {{ ssn }}",
      "delete.button": "Slett meddommer {{ meddommer }} med fødselsnummer {{ ssn }}"
    }
  }
}
